import React from 'react';
import {COLORS} from '../../../constants/colors';
import {DrawerProps} from '../Drawer/Drawer';
import {DropDownProps} from '../Dropdown/Dropdown';
import {FlyoutProps} from '../Flyout/Flyout';
import {ContentAlignment, ModalDialogProps} from '../ModalDialog/ModalDialog';
import {OpenerType} from './ContentOpener';

export type ContentPopperBaseProps = {
  // content nodes
  openerContent?: React.ReactNode;
  headerContent?: React.ReactNode;
  bodyContent?: React.ReactNode;

  onClose: () => void;
  onOpenerClick?: () => void;

  open: boolean;
  isActive?: boolean;
  showHeaderDivider?: boolean;
  className?: string;
  style?: React.CSSProperties;
  dataTestId?: string;
  /**
   * Only applicable for modal and flyout
   */
  renderInPortal?: boolean;
  /**
   * Only applicable for drawer
   */
  slideDirection?: 'left' | 'right';
  hideBodyBorderTop?: boolean;
  hideHeader?: boolean;

  /**
   * Only applicable for modal
   */
  showCloseIcon?: boolean;
  fixedSmallWidth?: boolean;
  preventSlideUpAnimation?: boolean;
  contentFitWidth?: boolean;
  openerAlignment?: ContentAlignment;

  /**
   * Only applicable for Dropdown
   */
  centerDropDownContent?: boolean;
  forceContentOpenerGreyBorder?: boolean;
  openerType?: OpenerType;
  forceContentOpenerIconColor?: keyof typeof COLORS;
};

export interface ContentPopperProps extends ContentPopperBaseProps {
  LayoutComponent:
    | React.FC<FlyoutProps>
    | React.FC<DropDownProps>
    | React.FC<ModalDialogProps>
    | React.FC<DrawerProps>;
}

export const ContentPopper: React.FC<ContentPopperProps> = ({
  LayoutComponent,
  ...props
}) => <LayoutComponent {...props} />;
